import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import CopyAnalysisKeyButton from 'analysis-tool/ui/main-view/third-party-step/CopyAnalysisKeyButton';
import isArchived from 'archive/isArchived';
import {FONT_PROXIMA_13} from 'styles/FontConstants';

import {AnalysisRightSidebarItemType, RightSidebarComponentProps} from '../RightSidebarTypes';
import RightSidebarSkeleton, {RightSidebarWidth} from './RightSidebarSkeleton';

export default function ThirdPartyImportRightSidebar({
  analysis,
  onChangeSelectedRightSidebarItem,
}: RightSidebarComponentProps<AnalysisRightSidebarItemType.THIRD_PARTY_IMPORT>): JSX.Element {
  return (
    <RightSidebarSkeleton
      title="Connect with external tool"
      confirmationButtons={[
        {
          text: 'Close',
          onClick: () => {
            onChangeSelectedRightSidebarItem(null);
          },
          dataTestAttrsElement: 'close',
        },
      ]}
      width={RightSidebarWidth.STANDARD}
      dataTestAttrs={{
        component: 'ThirdPartyImportRightSidebar',
        element: 'root',
      }}
    >
      <div className={css(styles.bodyText)}>
        Send or receive data from an external analytics tool. Depending on your connection, you may need an
        Analysis key.
      </div>
      <CopyAnalysisKeyButton analysisId={analysis.id} disabled={isArchived(analysis)} />
    </RightSidebarSkeleton>
  );
}

const styles = StyleSheet.create({
  bodyText: {
    ...FONT_PROXIMA_13,
    marginBottom: 11,
  },
});
